import { userTypes } from 'src/types/userTypes';

export const getUserTypeLabel = (value) => {
  const userType = userTypes.find((type) => type.value === value);
  return userType ? userType.label : 'Bilinmiyor';
};
